import {GamePopupDefaultBox} from "./game-popup.default.box";

export const GamesGridBox = GamePopupDefaultBox;